"use strict";

exports.__esModule = true;
var _AppIcon = require("./AppIcon");
Object.keys(_AppIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppIcon[key]) return;
  exports[key] = _AppIcon[key];
});